import { DisplayCategoryFragment, GeoRegionInput, GetExternalOffersQueryVariables } from '@ocx/graphql';

export const getExternalOfferConfigurationUuids = (
  categories: Array<Pick<DisplayCategoryFragment, 'bannerIds'>>,
): string[] =>
  categories.reduce((acc, { bannerIds }) => (bannerIds?.length ? [...acc, ...bannerIds] : acc), [] as string[]);

export const getEagerExternalOfferConfigurationUuids = (categories: DisplayCategoryFragment[]): string[] =>
  getExternalOfferConfigurationUuids(categories.filter((category) => !category.shouldLazyLoadBanners));

export const createExternalOffersQueryVariables = (
  bannerConfigurationUuidIncludes: string[],
  currentLocation?: GeoRegionInput | null,
): GetExternalOffersQueryVariables => {
  const hasRegion = !!(currentLocation?.state || currentLocation?.zipCode);

  return {
    filter: {
      bannerConfigurationUuidIncludes,
    },
    ...(hasRegion ? { context: { currentLocation } } : {}),
  };
};

export const createExternalOffersQueryVariablesFromCategories = (
  categories: DisplayCategoryFragment[],
  currentLocation?: GeoRegionInput | null,
): GetExternalOffersQueryVariables =>
  createExternalOffersQueryVariables(getEagerExternalOfferConfigurationUuids(categories), currentLocation);
